export enum SiteProvisionStatus {
  Idle = 'Idle',
  TemplateRequested = "Requested",
  TemplateProcessing = "Processing",
  CloseRequested = "Close Requested",
  CloseProcessing = "Close Processing",
  Closed = 'Closed',
  ArchiveRequested = "Archive Requested",
  ArchiveProcessing = "Archive Processing",
  Archived = 'Archived',
}
